import {mapActions, mapGetters} from "vuex";
import {GET_DAM_DATA, SET_CURRENT_DAM} from "../store/actions/dashboard";
import {REFRESH_TOKEN} from "../store/actions/auth";

export default {
    data() {
        return {
            loading: false
        }
    },
    async mounted() {
        await this.REFRESH_TOKEN();
        await this.fetchDamData();
        await this.setCurrentDamItem();
    },
    computed: {
        ...mapGetters(['getDamData', 'currentDamSelectedId'])
    },
    methods: {
        ...mapActions([REFRESH_TOKEN, GET_DAM_DATA, SET_CURRENT_DAM]),
        async fetchDamData() {
            if (this.$route.params.id) {
                this.loading = true;
                await this.GET_DAM_DATA(this.$route.params.id);
                this.loading = false;
            }
        },
        async setCurrentDamItem() {
            // if fresh loaded the page and no dam is selected, use the dam data
            if (this.getDamData && this.getDamData.asList) {
                const idFromDamData = `${this.getDamData.asList[0]}_${this.getDamData.asList[1]}`;

                if (this.currentDamSelectedId !== idFromDamData) {
                    this.SET_CURRENT_DAM(this.getDamData.asList);
                }
            }
        }
    }
};